import React from "react";
import { useTranslation } from "react-i18next";

import { Container, Box } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";
import { Routes, Route, Navigate } from "react-router-dom";
import PriceList from "./Views/PriceList";
import About from "./Views/About";
import Contact from "./Views/Contact";
import TopBar from "./Components/TopBar";
import Footer from "./Components/Footer";
import { useLocation } from "react-router-dom";
const useStyles = makeStyles((theme: Theme) => ({
  root: {
    backgroundColor: theme.palette.background.default,
    display: "flex",
    flexDirection: "column",
    minHeight: "100vh",
  },
  content: {
    flexGrow: 1,
  },
}));

const App = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const location = useLocation();
  const page = location.pathname.split("/")[1];
  return (
    <div className={classes.root}>
      <TopBar />
      <Box className={classes.content}>
        <Container>
          <Routes>
            <Route path="/" element={<Navigate to="/pricelist" />} />
            <Route path="/pricelist" element={<PriceList />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </Container>
      </Box>
      {page !== "contact" && <Footer />}
    </div>
  );
};

export default App;
